import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input, TextArea, Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";

import { CardCondPag, Container } from "./styles";
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from "~/services/api";

function CondPagList({ defaultData, setter, tipo, valorTotal, atividades }) {
  const condpagPad = [
    { item: 1, id: 0, tipo: tipo, diasVencimento: 0, dataVencimento: "", percentualValor: 0, valor: 0, idOrcamentoAtividade: 0 },
  ];
  const [condpags, setCondPags] = useState([]);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        if (edit) {
          let aCondPag = [];
          let item = 1;
          for (const itemCondPag of defaultData) {
            if (tipo == itemCondPag?.tipo) {
              aCondPag.push({ item, ...(itemCondPag) });

              item++;
            }
          }
          setCondPags(aCondPag);
          setter(aCondPag);
        }
      } else {
        if (!(edit && editShow)) {
          setCondPags(condpagPad);
          setter(condpagPad);
        }
      }
    }
  }, [edit, editShow, tipo]);

  useEffect(() => {
    setter(condpags);
  }, [condpags]);

  function handleAddCondPag() {
    setCondPags((prev) => [...prev, { item: (condpags?.length > 0 ? condpags[condpags?.length - 1]?.item + 1 : 1), id: 0, tipo: tipo, diasVencimento: 0, dataVencimento: "", percentualValor: 0, valor: 0, idOrcamentoAtividade: 0 }]);
  }

  function handleRemoveCondPag(data) {
    setCondPags((prev) => {
      const newPrev = [...prev];
      const checkIndex = prev.findIndex((e) => e?.item === data?.item);

      if (checkIndex >= 0) {
        newPrev.splice(checkIndex, 1);
      }

      return newPrev;
    });
  }

  return (
    <Container>
      <Label title="Condições de Pagamentos *" className="titulo-label" row={true}>
        {!(editShow && edit) ? (
          <ColoredButton small blueLayout type="button" onClick={handleAddCondPag}>
            Adicionar
          </ColoredButton>
        ) : (
          <ColoredButton small disabledLayout type="button">
            Adicionar
          </ColoredButton>
        )}
      </Label>
      {
        tipo == "P" ? (
          <CardCondPag>
            <div className="card-atv-header">
              <div className="titulos-tab">
                <div className="col w1">
                  <div className="top-header">
                    -
                  </div>
                </div>
                <div className="col w5">
                  <p className="titulo">Data Vencimento <span>*</span></p>
                </div>
                <div className="col w2">
                  <p className="titulo">Valor <span>*</span></p>
                </div>
              </div>
            </div>
            {condpags?.map((itemData, index) => (
              <div className="card-atv-body">
                <div className="row no-margin row-top">
                  <div className="w1">
                    <div className="top-header">
                      <div onClick={(e) => { handleRemoveCondPag(itemData) }} className="icon-button material-icons">delete</div>
                    </div>
                  </div>
                  <div className="w5">
                    <Input
                      placeholder="Data de Vencimento"
                      name="dataVencimentoCondPagAt"
                      required="true"
                      type="date"
                      value={itemData?.dataVencimento}
                      onChange={(e) => {
                        const v = e.currentTarget.value || "";
                        setCondPags((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[index].dataVencimento = v;
    
                          return newPrev;
                        });
                      }}
                    />
                  </div>
                  <div className="w2">
                    <Input
                      type="number"
                      name="valorAt"
                      required="true"
                      value={itemData?.valor}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setCondPags((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[index].valor = parseInt(v);
    
                          return newPrev;
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </CardCondPag>
        ) : tipo == "E" ? (
          <CardCondPag>
            <div className="card-atv-header">
              <div className="titulos-tab">
                <div className="col w1">
                  <div className="top-header">
                    -
                  </div>
                </div>
                <div className="col w4">
                  <p className="titulo">Atividade <span>*</span></p>
                </div>
                <div className="col w1">
                  <p className="titulo">% <span>*</span></p>
                </div>
                <div className="col w2">
                  <p className="titulo">Valor <span>*</span></p>
                </div>
              </div>
            </div>
            {condpags?.map((itemData, index) => (
              <div className="card-atv-body">
                <div className="row no-margin row-top">
                  <div className="w1">
                    <div className="top-header">
                      <div onClick={(e) => { handleRemoveCondPag(itemData) }} className="icon-button material-icons">delete</div>
                    </div>
                  </div>
                  <div className="w4">
                    <Select
                      required="true"
                      isString
                      list={{ list: atividades, value: "id", label: "titulo" }}
                      name="idOrcamentoAtividade"
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setCondPags((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[index].idOrcamentoAtividade = v;
    
                          return newPrev;
                        });
                      }}
                      defaultValue={itemData?.idOrcamentoAtividade}
                    />
                  </div>
                  <div className="w1">
                    <Input
                      type="number"
                      name="percentualValorAt"
                      required="true"
                      value={itemData?.percentualValor}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setCondPags((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[index].percentualValor = parseFloat(v);
                          newPrev[index].valor = ((parseFloat(v) / 100) * valorTotal).toFixed(2);
                          
                          return newPrev;
                        });
                      }}
                    />
                  </div>
                  <div className="w2">
                    <Input
                      type="number"
                      name="valorAt"
                      required="true"
                      value={itemData?.valor}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setCondPags((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[index].valor = parseFloat(v);
                          newPrev[index].percentualValor = ((parseFloat(v) * 100) / valorTotal).toFixed(2);
    
                          return newPrev;
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </CardCondPag>
        ) : tipo == "A" ? (
          <CardCondPag>
            <div className="card-atv-header">
              <div className="titulos-tab">
                <div className="col w1">
                  <div className="top-header">
                    -
                  </div>
                </div>
                <div className="col w5">
                  <p className="titulo">Dia Vencimento <span>*</span></p>
                </div>
                <div className="col w2">
                  <p className="titulo">Valor Hora<span>*</span></p>
                </div>
              </div>
            </div>
            {condpags?.map((itemData, index) => (
              <div className="card-atv-body">
                <div className="row no-margin row-top">
                  <div className="w1">
                    <div className="top-header">
                      <div onClick={(e) => { handleRemoveCondPag(itemData) }} className="icon-button material-icons">delete</div>
                    </div>
                  </div>
                  <div className="w5">
                    <Input
                      placeholder="Dia de Vencimento"
                      name="diasVencimentoCondPagAt"
                      required="true"
                      type="number"
                      value={itemData?.diasVencimento}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setCondPags((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[index].diasVencimento = v;
    
                          return newPrev;
                        });
                      }}
                    />
                  </div>
                  <div className="w2">
                    <Input
                      type="number"
                      name="valorAt"
                      required="true"
                      value={itemData?.valor}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setCondPags((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[index].valor = parseInt(v);
    
                          return newPrev;
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </CardCondPag>
        ) : (
          <CardCondPag>
            <div className="card-atv-header">
              <div className="titulos-tab">
                <div className="col w1">
                  <div className="top-header">
                    -
                  </div>
                </div>
                <div className="col w4">
                  <p className="titulo">Dia DDL <span>*</span></p>
                </div>
                <div className="col w1">
                  <p className="titulo">% <span>*</span></p>
                </div>
                <div className="col w2">
                  <p className="titulo">Valor <span>*</span></p>
                </div>
              </div>
            </div>
            {condpags?.map((itemData, index) => (
              <div className="card-atv-body">
                <div className="row no-margin row-top">
                  <div className="w1">
                    <div className="top-header">
                      <div onClick={(e) => { handleRemoveCondPag(itemData) }} className="icon-button material-icons">delete</div>
                    </div>
                  </div>
                  <div className="w4">
                    <Input
                      placeholder="Dias DDL *"
                      name="diasVencimentoCondPagAt"
                      required="true"
                      type="number"
                      value={itemData?.diasVencimento}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setCondPags((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[index].diasVencimento = v;
    
                          return newPrev;
                        });
                      }}
                    />
                  </div>
                  <div className="w1">
                    <Input
                      type="number"
                      name="percentualValorAt"
                      required="true"
                      value={itemData?.percentualValor}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setCondPags((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[index].percentualValor = parseFloat(v);
                          newPrev[index].valor = ((parseFloat(v) / 100) * valorTotal).toFixed(2);
                          
                          return newPrev;
                        });
                      }}
                    />
                  </div>
                  <div className="w2">
                    <Input
                      type="number"
                      name="valorAt"
                      required="true"
                      value={itemData?.valor}
                      onChange={(e) => {
                        const v = e.currentTarget.value || 0;
                        setCondPags((prev) => {
                          let newPrev = [...prev];
    
                          newPrev[index].valor = parseFloat(v);
                          newPrev[index].percentualValor = ((parseFloat(v) * 100) / valorTotal).toFixed(2);
    
                          return newPrev;
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </CardCondPag>
        )
      }
    </Container>
  );
}

export default CondPagList;
